var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15ZM5.59091 6.54545H3.95455C3.42736 6.54545 3 6.97282 3 7.5C3 8.02718 3.42736 8.45455 3.95455 8.45455H5.59091C6.11809 8.45455 6.54545 8.88191 6.54545 9.40909V11.0455C6.54545 11.5726 6.97282 12 7.5 12C8.02718 12 8.45455 11.5726 8.45455 11.0455V9.40909C8.45455 8.88191 8.88191 8.45455 9.40909 8.45455H11.0455C11.5726 8.45455 12 8.02718 12 7.5C12 6.97282 11.5726 6.54545 11.0455 6.54545H9.40909C8.88191 6.54545 8.45455 6.11809 8.45455 5.59091V3.95455C8.45455 3.42736 8.02718 3 7.5 3C6.97282 3 6.54545 3.42736 6.54545 3.95455V5.59091C6.54545 6.11809 6.11809 6.54545 5.59091 6.54545Z",
    fill: "#A1A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.3785861a40c5607d2b3e324c24c782b6.svg";
export { ForwardRef as ReactComponent };